import { render, staticRenderFns } from "./vPackageCard.vue?vue&type=template&id=5b80b8a4&scoped=true"
import script from "./vPackageCard.vue?vue&type=script&lang=ts"
export * from "./vPackageCard.vue?vue&type=script&lang=ts"
import style0 from "./vPackageCard.vue?vue&type=style&index=0&id=5b80b8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b80b8a4",
  null
  
)

export default component.exports